<template>
  <input
    :name="name"
    :type="type"
    class="form-control"
    :class="{ 'input-danger': isInvalid }"
    :value="value"
    :disabled="disabled"
    v-on="inputListeners"
    @keypress="onKeydown()"
    @change="update"
    :maxLength="maxLength"
  />
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    value: {
      type: [String, Number],
      required: false
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: String,
      required: false,
      default: 'text',
      validator: value => ['text', 'tel', 'email', 'number', 'password'].indexOf(value) !== -1
    },
    isNumber: {
      type: Boolean,
      required: false,
      default: false
    },
    minValue: {
      type: Number,
      required: false
    },
    maxValue: {
      type: Number,
      required: false
    },
    isInvalid: {
      type: Boolean,
      required: false,
      default: false
    },
    maxLength: {
      type: Number,
      required: false,
      default: 524288
    }
  },
  computed: {
    inputListeners() {
      let vm = this
      return Object.assign({}, this.$listeners, {
        input: function(event) {
          vm.emitEvent.call(vm, event, 'input')
        },
        change: function(event) {
          vm.emitEvent.call(vm, event, 'change')
        }
      })
    }
  },
  updated() {
    if (this.name === 'login') {
      this.$emit('input', this.value)
    }
  },
  methods: {
    onKeydown() {
      let evt = window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (this.type == 'tel') {
        if (/\d/.test(evt.key) || charCode == 46 || charCode == 8 || (!evt.target.value && evt.key == '+')) {
          return true
        } else return evt.preventDefault()
      }
      if (this.isNumber) {
        if (/\d/.test(evt.key)) {
          return true
        } else return evt.preventDefault()
      }
      return true
    },
    emitEvent(event, eventName) {
      let value = event.target.value

      if (this.type == 'tel') {
        value = value.replace(/[^+\d]/g, '')
      }
      this.$emit(eventName, value)
    }
  }
}
</script>
